import React from "react";
import { Container } from "semantic-ui-react";

import StepBar from "../components/stepBar";
import Footer from "../components/footer";

// Something that all pages should include
const Wrapper = props => (
  <div className="App">
    <StepBar />
      <Container>{props.children}</Container>
    <Footer />
  </div>
);

export default Wrapper;



// WEBPACK FOOTER //
// ./src/pages/wrapper.js